/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

// utils/metaTags.ts
import pageMetaDataJson from "../data/pageMetaData.json"

export const updateMetaTags = (title: string, description: string, keywords?: string) => {
  // Update document title
  document.title = title

  // Update meta description
  const metaDescription = document.querySelector('meta[name="description"]')
  if (metaDescription) {
    metaDescription.setAttribute("content", description)
  }

  // Update meta keywords if provided
  if (keywords) {
    const metaKeywords = document.querySelector('meta[name="keywords"]')
    if (metaKeywords) {
      metaKeywords.setAttribute("content", keywords)
    }
  }

  // Update Open Graph tags
  const ogTitle = document.querySelector('meta[property="og:title"]')
  if (ogTitle) {
    ogTitle.setAttribute("content", title)
  }

  const ogDescription = document.querySelector('meta[property="og:description"]')
  if (ogDescription) {
    ogDescription.setAttribute("content", description)
  }

  // Update canonical URL
  let canonical = document.querySelector('link[rel="canonical"]')
  if (!canonical) {
    canonical = document.createElement("link")
    canonical.setAttribute("rel", "canonical")
    document.head.appendChild(canonical)
  }
  canonical.setAttribute("href", window.location.href)
}

// Page-specific meta data. Kept in src/data/pageMetaData.json rather than inline so that
// scripts/generateRouteHtml.mjs - which stamps this same title/description/keywords into
// each route's built HTML at build time (see #233) - can read it without a TS toolchain.
export const pageMetaData = pageMetaDataJson
